export var EXTENSION_PREFIXES = ['chrome-extension://', 'moz-extension://'];
export function containsExtensionUrl(str) {
  return EXTENSION_PREFIXES.some(function (prefix) {
    return str.includes(prefix);
  });
}
/**
 * Utility function to detect if the SDK is being initialized in an unsupported browser extension environment.
 * @param windowLocation The current window location to check
 * @param stack The error stack to check for extension URLs
 * @returns {boolean} true if running in an unsupported browser extension environment
 */
export function isUnsupportedExtensionEnvironment(windowLocation) {
  var stack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Error().stack;
  // If we're on a regular web page but the error stack shows extension URLs,
  // then an extension is injecting RUM.
  return !containsExtensionUrl(windowLocation) && containsExtensionUrl(stack || '');
}